"use client";
import { cdnFlightPath } from "@/constants/cdnUrls";
import { Link } from "@/i18n/navigation";
import Image from "next/image";

export default function BenefitCard({ item }) {
  const getIconComponent = (iconName) => {
    switch (iconName) {
      case "SmartFlight":
        return { type: "image", src: `${cdnFlightPath}benefits/smart-fly.svg` };
      case "OnlineMonitor":
        return {
          type: "image",
          src: `${cdnFlightPath}benefits/online-cancel.svg`,
        };
      case "Cancellation":
        return {
          type: "image",
          src: `${cdnFlightPath}benefits/cancellation-and-refund.svg`,
        };
      default:
        return null;
    }
  };

  const IconComponent = getIconComponent(item.icon);
  const href = item.href || item.link || null;

  const cardContent = (
    <>
      <div className="relative flex h-15 w-18 items-center justify-center overflow-hidden">
        {IconComponent && IconComponent.type === "image" ? (
          <Image
            src={IconComponent.src}
            alt={item.title || "Benefit icon"}
            width={72}
            height={72}
            className="object-contain"
          />
        ) : IconComponent ? (
          <IconComponent className="h-15 w-18" />
        ) : null}
      </div>
      <div className="flex flex-col items-start justify-center gap-2">
        {item.title && (
          <div className="line-clamp-1 h-[26px] text-lg font-semibold">
            {item.title}
          </div>
        )}
        {item.description && (
          <div className="text-primary-muted-subtext line-clamp-3 text-base leading-[21px] font-normal">
            {item.description}
          </div>
        )}
      </div>
    </>
  );

  return (
    <div
      key={item.id}
      className={`items-left shadow-small mr-4 flex w-full min-w-[294px] flex-col justify-start gap-3 rounded-lg bg-white p-6 ${
        href ? "cursor-pointer" : ""
      }`}
    >
      {href ? (
        <Link href={href} title={item?.title || ""} className="flex flex-col gap-3">
          {cardContent}
        </Link>
      ) : (
        cardContent
      )}
    </div>
  );
}
